/* eslint-disable no-prototype-builtins */
import api from '../../utils/api';

const serialize = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};

const url = 'tickets';
const couponUrl = 'coupons';
export default {
  fetchTicketEvent: (payload) => api.get(`${url}/events/${payload}`),
  ticketCheckout: (payload) => api.post(`${url}/checkout`, payload),
  calculateTicketCost: (payload) => api.post(`${url}/calculate`, payload),
  checkIn: (payload) => api.post(`${url}/check-in`, payload, true),
  resendCheckInWaiver: (payload) =>
    api.post(`${url}/check-in/waiver/resend`, payload),
  getListEvents: (payload) =>
    api.get(
      `${url}/publish-events/${payload.businessId}?verificationCode=${payload.verificationCode}`
    ),
  getEventDetail: (id) => api.get(`${url}/events/${id}`),
  fetchTicket: (payload) => api.get(`${url}/${payload}`),
  reservedOrder: (orderId) =>
    api.deleteRequest(`${url}/reserved-order/${orderId}`),
  validateTicketCoupon: (payload) =>
    api.post(`${couponUrl}/validate-ticket-coupon`, payload),
  submitTicketFreeAPI: (payload) =>
    api.post(`${url}/free-ticket-checkout`, payload),
  getTicketSetupApi: (id) => api.get(`${url}/misc/${id}`),
  getTickets: (params) =>
    api.makeEndpoint(
      'get',
      `${url}/event/${params.eventId}/tickets?${serialize(params)}`
    )(),
};
